import React from "react";
import PropTypes from "prop-types";
import zxcvbn from "zxcvbn";

import ProgressRing from "../Progress/ProgressRing";
import "./PasswordInput.scss";

export default class PasswordInput extends React.Component {
  state = {
    hidden: true,
    score: -1,
    showEyes: false
  };

  onChange = e => {
    const password = e.target.value;
    if (password === "") this.setState({ score: -1, showEyes: false });
    else this.setState({ score: zxcvbn(password).score, showEyes: false });
  };

  toggleHide = () => {
    this.setState({ hidden: !this.state.hidden, showEyes: this.state.hidden });
  };

  emojiToDisplay = () => {
    if (this.state.score === -1) return "";
    if (this.state.showEyes) {
      return (
        <img
          src={require("../../assets/login/view.png")}
          alt="eyes emoji"
          width={30}
        />
      );
    }

    return (
      <img
        src={require(`../../assets/login/strength-meter/strength-${
          this.state.score
        }.png`)}
        alt="emoji strength"
        width={30}
      />
    );
  };

  render() {
    return (
      <div className="passwordInputContainer">
        <input
          type={this.state.hidden ? "password" : "text"}
          autoComplete={this.props.autoComplete}
          placeholder={this.props.placeholder}
          onChange={e => {
            this.props.onChange(e);
            this.onChange(e);
          }}
          value={this.props.value}
          style={!this.props.showEmojiMeter ? { borderRadius: 12 } : {}}
        />
        {this.props.showEmojiMeter && (
          <div className="passStrength" onClick={this.toggleHide}>
            <span id="emojiContainer">{this.emojiToDisplay()}</span>
            <ProgressRing
              radius={30}
              stroke={4}
              progress={(this.state.score + 1) * 20}
            />
          </div>
        )}
      </div>
    );
  }
}

PasswordInput.propTypes = {
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  showEmojiMeter: PropTypes.bool
};
